<h3 mat-dialog-title="">{{ data.title | translate }}</h3>
<mat-dialog-content>
  {{ data.message | translate }}

  @if (data.list && data.list.length > 0) {
    <ul>
      @for (item of data.list; track item) {
        <li>{{ item }}</li>
      }
    </ul>
  }
</mat-dialog-content>
<mat-dialog-actions class="mt1 flex justify-start content-center items-center flex-row gap-[1rem]">
  <button mat-flat-button="" color="primary" [mat-dialog-close]="true"><span translate="">Yes</span></button>
  <button mat-stroked-button="" [mat-dialog-close]="false" cdkFocusInitial=""><span translate="">No</span></button>
</mat-dialog-actions>